import React, { useContext, useMemo } from 'react';
import { StaticContext } from '@sm/webassets';

import HelmetWithChildren from '~pricing/lib/HelmetWrapper';
import { SeoHeadTags, HrefLangsTags } from '~pricing/components/SEO';

import { getLinks, Links } from './links';

type SeoProps = {
  canonicalPath?: string;
  children?: React.ReactNode;
};

export default function Seo({ canonicalPath = '', children }: SeoProps): JSX.Element {
  const {
    environment: { domain },
    url,
  } = useContext(StaticContext);
  const path = canonicalPath || url;
  const hrefLangs = useMemo(() => getLinks(domain, path) as Links[], [domain, path]);
  return (
    <>
      <HelmetWithChildren>
        {/*
          these need to be referenced as function calls because of Helmet's requirements for children:
          https://github.com/nfl/react-helmet/issues/326
        */}
        {SeoHeadTags()}
        {HrefLangsTags({ hrefLangs, path })}
      </HelmetWithChildren>
      {children}
    </>
  );
}
